import {Bot, Search} from 'lucide-react'
import FadeIn from '@/components/FadeIn'

function WhatIsSection() {
  return (
    <section id="what" className="bg-neutral-950 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <FadeIn className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-emerald-400">
            Разбираемся в терминах
          </span>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-white sm:text-4xl">
            Что такое SEO и GEO
          </h2>
          <p className="mt-4 text-neutral-400">
            Два подхода, которые вместе закрывают весь путь пользователя — от поисковой строки до диалога с нейросетью
          </p>
        </FadeIn>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
          <FadeIn className="rounded-2xl border border-neutral-800 bg-neutral-900/40 p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-400/10">
              <Search className="h-6 w-6 text-emerald-400" />
            </div>
            <h3 className="mt-5 text-xl font-bold text-white">SEO — поисковая оптимизация</h3>
            <p className="mt-3 text-sm leading-relaxed text-neutral-400">
              SEO (Search Engine Optimization) — комплекс работ по продвижению сайта в
              выдаче Яндекса и Google по запросам, которые вводят ваши потенциальные клиенты.
              Мы прорабатываем техническую часть сайта, контент, ссылочный профиль и
              поведенческие факторы, чтобы поднять сайт в топ-5 выдачи и получать стабильный
              поток целевых обращений.
            </p>
          </FadeIn>

          <FadeIn delay={100} className="rounded-2xl border border-neutral-800 bg-neutral-900/40 p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-400/10">
              <Bot className="h-6 w-6 text-emerald-400" />
            </div>
            <h3 className="mt-5 text-xl font-bold text-white">GEO — оптимизация для нейросетей</h3>
            <p className="mt-3 text-sm leading-relaxed text-neutral-400">
              GEO (Generative Engine Optimization) — новое направление продвижения,
              нацеленное на то, чтобы ваш бизнес упоминался в ответах ChatGPT, Perplexity,
              DeepSeek, Gemini и Алисы. Пользователи всё чаще ищут решения через диалог
              с нейросетью — GEO помогает бренду появляться именно в этих ответах.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>
  )
}

export default WhatIsSection
